import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/indexPage.vue'
import Login from '../views/loginPage.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/detail',
    name: 'detail',
    // 将Details组件改为异步加载，并添加webpackPrefetch
    component: () => import(/* webpackPreload: true */ '../views/detailPage.vue')
  },
  {
    path: '/link',
    name: 'link',
    // 将Details组件改为异步加载，并添加webpackPrefetch
    component: () => import(/* webpackPreload: true */ '../views/link.vue')
  },
  {
    path: '/helpDetail',
    name: 'helpDetail',
    component: () => import(/* webpackPreload: true */ '../views/helpDetail.vue')
  },
]

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // 检查即将进入的路由是否是 'detail'
  if (to.name === 'detail') {
    // 检查是否从 'home' 页面来
    // if (from.name !== 'home') {
    //   // 如果不是从 'home' 页面来，重定向到 'home'
    //   next({ name: 'home' });
    // } else {
    //   // 如果是从 'home' 页面来，正常导航
    //   next();
    // }
    next();
  } else {
    // 如果访问的不是 'detail' 页面，正常导航
    next();
  }
});
export default router
